import { action, observable, runInAction } from 'mobx';
import { StringStore } from 'ui/base/input';
import * as PasswordResetService from 'services/accounts/password_reset_service';
import { ResultKind } from 'services/base/types';
import { BusyStore } from 'ui/base/button';

export class PasswordResetStore {
  readonly email: StringStore;

  @observable.ref
  emailError: string | undefined;

  @observable.ref
  busy: BusyStore;

  constructor() {
    this.email = new StringStore('');
    this.busy = new BusyStore();
  }

  @action.bound
  async handlePasswordReset(): Promise<PasswordResetService.CreateResult> {
    this.emailError = undefined;
    const result = await PasswordResetService.post(this.email.value);
    return runInAction(() => {
      if (result.kind === ResultKind.USER_ERROR) {
        this.emailError = result.emailError;
      }
      return result;
    });
  }
}
